export function inventoryNavigationState(location) {
  return { inventoryParent: { pathname: location.pathname, search: location.search } };
}

// Pop a known parent entry; direct links fall back to the parent without pushing a duplicate.
export function inventoryBackTarget(location) {
  const match = location.pathname.match(/^(\/admin\/inventories)\/([^/]+)(\/history)?\/?$/);
  if (!match) return null;

  const pathname = match[3] ? `${match[1]}/${match[2]}` : match[1];
  const target = { pathname, search: location.search };
  const parent = location.state?.inventoryParent;
  if (parent?.pathname === pathname && parent.search === location.search) return -1;
  return target;
}
